// extracted by mini-css-extract-plugin
export var card = "card-module--card--7E8cV";
export var horizontal = "card-module--horizontal--OiBWB";
export var cardHeader = "card-module--card-header--2Gy5z";
export var cardImage = "card-module--card-image--RSVpn";
export var cardBody = "card-module--card-body--cuM3M";
export var cardBodyTitle = "card-module--card-body-title--MA+ow";
export var cardBodyType = "card-module--card-body-type--r1KiI";
export var cardBodyDate = "card-module--card-body-date--2-3z3";
export var cardBodyDescription = "card-module--card-body-description--sWSWk";